module.exports = __webpack_public_path__ + "img/Parking-Icon.3151dd5f.webp";